import { DocumentReadOnlyReason } from "generated-graphql/graphql";

const READ_ONLY_MESSAGES: Record<DocumentReadOnlyReason, string> = {
  [DocumentReadOnlyReason.ArchivedFacility]:
    "This document is filed at an archived facility, which is read-only",
  [DocumentReadOnlyReason.LinkedChemical]:
    "You do not have permission to edit the chemical this SDS is attached to",
  [DocumentReadOnlyReason.NoPermission]: "You do not have permission to edit this document",
};

type WriteAccessDocument = {
  canWrite: boolean;
  readOnlyReason?: DocumentReadOnlyReason | null;
};

/** Why a document the user can't edit is locked, for the tooltip on its locked actions. */
export function readOnlyDocumentMessage(document: WriteAccessDocument): string {
  return READ_ONLY_MESSAGES[document.readOnlyReason ?? DocumentReadOnlyReason.NoPermission];
}

/**
 * The URL-named document when the user can't edit it, so a link to it opens
 * read-only details instead of a form the API would refuse to save.
 */
export function readOnlyLinkedDocument<T extends WriteAccessDocument & { id: string }>(
  document: T | null | undefined,
  documentId: string | null | undefined,
  canWriteDocument: boolean
): T | undefined {
  if (!document || document.id !== documentId) return undefined;
  return canWriteDocument && document.canWrite ? undefined : document;
}
